<template>
    <DefaultField
        :field="currentField"
        :errors="errors"
        :show-help-text="showHelpText"
        :full-width-content="fullWidthContent"
    >
        <template #field>
            <div class="flex items-center">
                <date-time-picker
                    class="w-full form-control form-input form-input-bordered"
                    ref="dateTimePicker"
                    :dusk="field.attribute"
                    :name="field.name"
                    :value="value"
                    :dateFormat="pickerFormat"
                    :alt-format="pickerDisplayFormat"
                    :placeholder="placeholder"
                    :enable-time="false"
                    :enable-seconds="false"
                    :first-day-of-week="firstDayOfWeek"
                    :class="errorClasses"
                    @change="handleChange"
                    :disabled="isReadonly"
                />

                <a
                    v-if="field.nullable"
                    @click.prevent="$refs.dateTimePicker.clear()"
                    href="#"
                    :title="__('Clear value')"
                    tabindex="-1"
                    class="p-1 px-2 cursor-pointer leading-none focus:outline-none"
                    :class="{
            'text-50': !value.length,
            'text-black hover:text-danger': value.length,
          }"
                >
                    <icon type="x-circle" width="22" height="22" viewBox="0 0 22 22"/>
                </a>
            </div>
        </template>
    </DefaultField>
</template>

<script>
    import isNil from 'lodash/isNil'
    import {DateTime} from 'luxon'
    import {DependentFormField, HandlesValidationErrors} from '@/mixins'
    import filled from '@/util/filled'
    import DateTimePicker from "../../globals/DateTimePicker";

    export default {
        mixins: [HandlesValidationErrors, DependentFormField],
        components: {
            'date-time-picker': DateTimePicker
        },
        methods: {
            /*
             * Set the initial value for the field
             */
            setInitialValue() {
                if (!isNil(this.currentField.value)) {
                    this.value = DateTime.fromISO(
                        this.currentField.value || this.value
                    ).toISODate()
                }
            },

            /**
             * On save, populate our form data
             */
            fill(formData) {
                if (this.currentlyIsVisible) {
                    this.fillIfVisible(formData, this.fieldAttribute, this.value)
                }
            },

            /**
             * Update the field's internal value
             */
            handleChange(event) {
                this.value = event?.target?.value ?? event

                if (this.field) {
                    this.emitFieldValueChange(this.fieldAttribute, this.value)
                }
            },
        },
        computed: {
            firstDayOfWeek() {
                return this.field.firstDayOfWeek || 0
            },

            placeholder() {
                return this.field.placeholder || this.todayDate
            },

            todayDate() {
                let today = new Date();

                // Get the current year, month, and day
                let year = today.getFullYear();
                let month = today.getMonth() + 1; // Months are zero-based, so add 1
                let day = today.getDate();

                // Ensure that the month and day have two digits
                month = month < 10 ? '0' + month : month;
                day = day < 10 ? '0' + day : day;

                // Form the YYYY-MM-DD date string
                return year + '-' + month + '-' + day;
            },

            format() {
                return this.field.format || 'YYYY-MM-DD'
            },

            pickerFormat() {
                return this.field.pickerFormat || 'Y-m-d'
            },

            pickerDisplayFormat() {
                return this.field.pickerDisplayFormat || 'Y-m-d'
            },
        },
    }
</script>
